import { helmsmarthomeTheme, helmConstants } from './helmsmarthome';
import { brightsuiteTheme, brightsuiteConstants } from './brightsuite';
import { homelinkTheme, homelinkConstants } from './homelink';

export const themeWrapper = () => {
    return {
        helmsmarthomeTheme,
        helmConstants,
        brightsuiteTheme,
        brightsuiteConstants,
        homelinkTheme,
        homelinkConstants,
    };
};

export default themeWrapper;
